module.exports = __webpack_public_path__ + "img/bg_avatar_male_01.86a79cb8.png";